import { KOMA_COUNT } from '~/constants/koma'
import { komaEndTime, komaIndexToTime } from '~/models/komaToTime'

/**
 * 分割供給契約のコマ (0〜47、両端を含む) を時刻で見せる helper。
 * 画面にコマ番号は出さない (番号では何時か分からない。2026-10-21 ユーザー指摘)。
 */

/** 開始側の選択肢: 00:00〜23:30 (値はコマ index)。 */
export const SLOT_START_OPTIONS: ReadonlyArray<{
  value: string
  label: string
}> = Array.from({ length: KOMA_COUNT }, (_, i) => ({
  value: String(i),
  label: komaIndexToTime(i),
}))

/** 終了側の選択肢: 00:30〜24:00 (値は終わるコマの index)。 */
export const SLOT_END_OPTIONS: ReadonlyArray<{ value: string; label: string }> =
  Array.from({ length: KOMA_COUNT }, (_, i) => ({
    value: String(i),
    label: komaEndTime(komaIndexToTime(i)),
  }))

/** 開始コマ index の時刻 ("08:00")。 */
export function slotStartLabel(index: number): string {
  return komaIndexToTime(index)
}

/** 終わるコマ index の終了時刻 ("22:00")。コマ 47 は "24:00" (折り返さない)。 */
export function slotEndLabel(index: number): string {
  return komaEndTime(komaIndexToTime(index))
}

/** コマ index の範囲を時刻で ("08:00〜22:00")。 `to` は終わるコマ。 */
export function slotRangeLabel(from: number, to: number): string {
  return `${slotStartLabel(from)}〜${slotEndLabel(to)}`
}
